module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "z-share",
    attrs: {
      "close-on-click-modal": false,
      "size": 'large',
      "title": "奖金分配",
      "visible": _vm.popFlag
    },
    on: {
      "close": _vm.deepClear,
      "update:visible": function($event) {
        _vm.popFlag = $event
      }
    }
  }, [_c('div', {
    staticClass: "head-center-text"
  }, [_vm._v(_vm._s(_vm._f("cycleStr")(_vm.data.bonus_cycle_detail)))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, _vm._l((_vm.assets), function(item, index) {
    return _c('div', {
      key: item.currency_id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.currency_name) + "：" + _vm._s(_vm.currency_show[index]))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        green: _vm.step == index + 1
      }
    })])
  })), _vm._v(" "), _c('table', {
    staticClass: "KBTable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_vm._v("任务数")]), _vm._v(" "), _c('td', [_vm._v("异常任务数")]), _vm._v(" "), _c('td', [_vm._v("罚单数")]), _vm._v(" "), _c('td', [_vm._v("罚币数量(币)")]), _vm._v(" "), _c('td', [_vm._v("奖金快币")])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "form",
      rawName: "v-form:share",
      arg: "share"
    }]
  }, _vm._l((_vm.bu_users), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.task_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.error_task_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ticket_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ticket_sum))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (_vm.assign_list[_vm.step - 1][item.id]),
        expression: "assign_list[step-1][item.id]"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.assign_list[_vm.step - 1][item.id]),
        expression: "assign_list[step-1][item.id]"
      }],
      attrs: {
        "type": "text",
        "rule": "bonus"
      },
      domProps: {
        "value": (_vm.assign_list[_vm.step - 1][item.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.assign_list[_vm.step - 1], item.id, $event.target.value)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "bonusNotice"
  }, [_vm._v("注*异常任务指的是执行中被取消的任务")]), _vm._v(" "), _c('p', {
    staticClass: "bonusNotice"
  }, [_vm._v("注*分配奖金必须为正整数")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step==1"
    }],
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step > 1),
      expression: "step>1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.step == _vm.stepLen ? "完成" : "下一步"))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-ca991dbc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/bonusShare.vue
// module id = 785
// module chunks = 1